import { render, staticRenderFns } from "./m-root-pharmacy-orders-new.vue?vue&type=template&id=6d5e57f3"
import script from "./m-root-pharmacy-orders-new.vue?vue&type=script&lang=js"
export * from "./m-root-pharmacy-orders-new.vue?vue&type=script&lang=js"
import style0 from "./m-root-pharmacy-orders-new.vue?vue&type=style&index=0&id=6d5e57f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports